import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { RunOnceScheduler, createCancelablePromise, disposableTimeout } from '../../../base/common/async.js';
import { onUnexpectedError, onUnexpectedExternalError } from '../../../base/common/errors.js';
import { toDisposable, DisposableStore, dispose as _dispose } from '../../../base/common/lifecycle.js';
import { StableEditorScrollState } from '../../browser/core/editorState.js';
import { registerEditorContribution, registerEditorAction, EditorAction } from '../../browser/editorExtensions.js';
import { CodeLensProviderRegistry } from '../../common/modes.js';
import { getCodeLensData } from './codelens.js';
import { CodeLensWidget, CodeLensHelper } from './codelensWidget.js';
import { ICommandService } from '../../../platform/commands/common/commands.js';
import { INotificationService } from '../../../platform/notification/common/notification.js';
import { ICodeLensCache } from './codeLensCache.js';
import * as dom from '../../../base/browser/dom.js';
import { hash } from '../../../base/common/hash.js';
import { IQuickInputService } from '../../../platform/quickinput/common/quickInput.js';
import { localize } from '../../../nls.js';
import { EditorContextKeys } from '../../common/editorContextKeys.js';

var CodeLensContribution = /*#__PURE__*/function () {
  function CodeLensContribution(_editor, _commandService, _notificationService, _codeLensCache) {
    var _this = this;

    _classCallCheck(this, CodeLensContribution);

    this._editor = _editor;
    this._commandService = _commandService;
    this._notificationService = _notificationService;
    this._codeLensCache = _codeLensCache;
    this._globalToDispose = new DisposableStore();
    this._localToDispose = new DisposableStore();
    this._lenses = [];
    this._oldCodeLensModels = new DisposableStore();
    this._modelChangeCounter = 0;
    this._isEnabled = this._editor.getOption(11
    /* codeLens */
    );

    this._globalToDispose.add(this._editor.onDidChangeModel(function () {
      return _this._onModelChange();
    }));

    this._globalToDispose.add(this._editor.onDidChangeModelLanguage(function () {
      return _this._onModelChange();
    }));

    this._globalToDispose.add(this._editor.onDidChangeConfiguration(function () {
      var prevIsEnabled = _this._isEnabled;
      _this._isEnabled = _this._editor.getOption(11
      /* codeLens */
      );

      if (prevIsEnabled !== _this._isEnabled) {
        _this._onModelChange();
      }
    }));

    this._globalToDispose.add(CodeLensProviderRegistry.onDidChange(this._onModelChange, this));

    this._globalToDispose.add(this._editor.onDidChangeConfiguration(function (e) {
      if (e.hasChanged(36
      /* fontInfo */
      )) {
        _this._updateLensStyle();
      }
    }));

    this._onModelChange();

    this._styleClassName = '_' + hash(this._editor.getId()).toString(16);
    this._styleElement = dom.createStyleSheet(dom.isInShadowDOM(this._editor.getContainerDomNode()) ? this._editor.getContainerDomNode() : undefined);

    this._updateLensStyle();
  }

  _createClass(CodeLensContribution, [{
    key: "dispose",
    value: function dispose() {
      this._localDispose();

      this._globalToDispose.dispose();

      this._oldCodeLensModels.dispose();

      _dispose(this._currentCodeLensModel);
    }
  }, {
    key: "_updateLensStyle",
    value: function _updateLensStyle() {
      var options = this._editor.getOptions();

      var fontInfo = options.get(36
      /* fontInfo */
      );
      var lineHeight = options.get(51
      /* lineHeight */
      );
      var height = Math.round(lineHeight * 1.1);
      var fontSize = Math.round(fontInfo.fontSize * 0.9);
      var newStyle = "\n\t\t.monaco-editor .codelens-decoration.".concat(this._styleClassName, " { height: ").concat(height, "px; line-height: ").concat(lineHeight, "px; font-size: ").concat(fontSize, "px; padding-right: ").concat(Math.round(fontInfo.fontSize * 0.45), "px;}\n\t\t.monaco-editor .codelens-decoration.").concat(this._styleClassName, " > a > .codicon { line-height: ").concat(lineHeight, "px; font-size: ").concat(fontSize, "px; }\n\t\t");
      this._styleElement.textContent = newStyle;
    }
  }, {
    key: "_localDispose",
    value: function _localDispose() {
      if (this._currentFindCodeLensSymbolsPromise) {
        this._currentFindCodeLensSymbolsPromise.cancel();

        this._currentFindCodeLensSymbolsPromise = undefined;
        this._modelChangeCounter++;
      }

      if (this._currentResolveCodeLensSymbolsPromise) {
        this._currentResolveCodeLensSymbolsPromise.cancel();

        this._currentResolveCodeLensSymbolsPromise = undefined;
      }

      this._localToDispose.clear();

      this._oldCodeLensModels.clear();

      _dispose(this._currentCodeLensModel);
    }
  }, {
    key: "_onModelChange",
    value: function _onModelChange() {
      var _this2 = this;

      this._localDispose();

      var model = this._editor.getModel();

      if (!model) {
        return;
      }

      if (!this._isEnabled) {
        return;
      }

      var cachedLenses = this._codeLensCache.get(model);

      if (cachedLenses) {
        this._renderCodeLensSymbols(cachedLenses);
      }

      if (!CodeLensProviderRegistry.has(model)) {
        // no provider -> return but check with
        // cached lenses. they expire after 30 seconds
        if (cachedLenses) {
          this._localToDispose.add(disposableTimeout(function () {
            var cachedLensesNow = _this2._codeLensCache.get(model);

            if (cachedLenses === cachedLensesNow) {
              _this2._codeLensCache.delete(model);

              _this2._onModelChange();
            }
          }, 30 * 1000));
        }

        return;
      }

      var _iterator = _createForOfIteratorHelper(CodeLensProviderRegistry.all(model)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var provider = _step.value;

          if (typeof provider.onDidChange === 'function') {
            var registration = provider.onDidChange(function () {
              return scheduler.schedule();
            });

            this._localToDispose.add(registration);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var detectVisibleLenses = this._detectVisibleLenses = new RunOnceScheduler(function () {
        return _this2._onViewportChanged();
      }, 250);
      var scheduler = new RunOnceScheduler(function () {
        var counterValue = ++_this2._modelChangeCounter;

        if (_this2._currentFindCodeLensSymbolsPromise) {
          _this2._currentFindCodeLensSymbolsPromise.cancel();
        }

        _this2._currentFindCodeLensSymbolsPromise = createCancelablePromise(function (token) {
          return getCodeLensData(model, token);
        });

        _this2._currentFindCodeLensSymbolsPromise.then(function (result) {
          if (counterValue === _this2._modelChangeCounter) {
            // only the last one wins
            if (_this2._currentCodeLensModel) {
              _this2._oldCodeLensModels.add(_this2._currentCodeLensModel);
            }

            _this2._currentCodeLensModel = result; // cache model to reduce flicker

            _this2._codeLensCache.put(model, result); // render lenses


            _this2._renderCodeLensSymbols(result);

            detectVisibleLenses.schedule();
          }
        }, onUnexpectedError);
      }, 250);

      this._localToDispose.add(scheduler);

      this._localToDispose.add(detectVisibleLenses);

      this._localToDispose.add(this._editor.onDidChangeModelContent(function () {
        _this2._editor.changeDecorations(function (decorationsAccessor) {
          _this2._editor.changeViewZones(function (viewZonesAccessor) {
            var toDispose = [];
            var lastLensLineNumber = -1;

            _this2._lenses.forEach(function (lens) {
              if (!lens.isValid() || lastLensLineNumber === lens.getLineNumber()) {
                // invalid -> lens collapsed, attach range doesn't exist anymore
                // line_number -> lenses should never be on the same line
                toDispose.push(lens);
              } else {
                lens.update(viewZonesAccessor);
                lastLensLineNumber = lens.getLineNumber();
              }
            });

            var helper = new CodeLensHelper();
            toDispose.forEach(function (l) {
              l.dispose(helper, viewZonesAccessor);

              _this2._lenses.splice(_this2._lenses.indexOf(l), 1);
            });
            helper.commit(decorationsAccessor);
          });
        }); // Compute new `visible` code lenses


        detectVisibleLenses.schedule(); // Ask for all references again

        scheduler.schedule();
      }));

      this._localToDispose.add(this._editor.onDidScrollChange(function (e) {
        if (e.scrollTopChanged && _this2._lenses.length > 0) {
          detectVisibleLenses.schedule();
        }
      }));

      this._localToDispose.add(this._editor.onDidLayoutChange(function () {
        detectVisibleLenses.schedule();
      }));

      this._localToDispose.add(toDisposable(function () {
        if (_this2._editor.getModel()) {
          var scrollState = StableEditorScrollState.capture(_this2._editor);

          _this2._editor.changeDecorations(function (decorationsAccessor) {
            _this2._editor.changeViewZones(function (viewZonesAccessor) {
              _this2._disposeAllLenses(decorationsAccessor, viewZonesAccessor);
            });
          });

          scrollState.restore(_this2._editor);
        } else {
          // No accessors available
          _this2._disposeAllLenses(undefined, undefined);
        }
      }));

      this._localToDispose.add(this._editor.onMouseUp(function (e) {
        if (e.target.type !== 9
        /* CONTENT_WIDGET */
        ) {
          return;
        }

        var target = e.target.element;

        if ((target === null || target === void 0 ? void 0 : target.tagName) === 'SPAN') {
          target = target.parentElement;
        }

        if ((target === null || target === void 0 ? void 0 : target.tagName) === 'A') {
          var _iterator2 = _createForOfIteratorHelper(_this2._lenses),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var lens = _step2.value;
              var command = lens.getCommand(target);

              if (command) {
                var _this2$_commandServic;

                (_this2$_commandServic = _this2._commandService).executeCommand.apply(_this2$_commandServic, [command.id].concat(_toConsumableArray(command.arguments || []))).catch(function (err) {
                  return _this2._notificationService.error(err);
                });

                break;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }));

      scheduler.schedule();
    }
  }, {
    key: "_disposeAllLenses",
    value: function _disposeAllLenses(decChangeAccessor, viewZoneChangeAccessor) {
      var helper = new CodeLensHelper();

      var _iterator3 = _createForOfIteratorHelper(this._lenses),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var lens = _step3.value;
          lens.dispose(helper, viewZoneChangeAccessor);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      if (decChangeAccessor) {
        helper.commit(decChangeAccessor);
      }

      this._lenses = [];
    }
  }, {
    key: "_renderCodeLensSymbols",
    value: function _renderCodeLensSymbols(symbols) {
      var _this3 = this;

      if (!this._editor.hasModel()) {
        return;
      }

      var maxLineNumber = this._editor.getModel().getLineCount();

      var groups = [];
      var lastGroup;

      var _iterator4 = _createForOfIteratorHelper(symbols.lenses),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var symbol = _step4.value;
          var line = symbol.symbol.range.startLineNumber;

          if (line < 1 || line > maxLineNumber) {
            // invalid code lens
            continue;
          } else if (lastGroup && lastGroup[lastGroup.length - 1].symbol.range.startLineNumber === line) {
            // on same line as previous
            lastGroup.push(symbol);
          } else {
            // on later line as previous
            lastGroup = [symbol];
            groups.push(lastGroup);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      var scrollState = StableEditorScrollState.capture(this._editor);

      this._editor.changeDecorations(function (decorationsAccessor) {
        _this3._editor.changeViewZones(function (viewZoneAccessor) {
          var helper = new CodeLensHelper();
          var codeLensIndex = 0;
          var groupsIndex = 0;

          while (groupsIndex < groups.length && codeLensIndex < _this3._lenses.length) {
            var symbolsLineNumber = groups[groupsIndex][0].symbol.range.startLineNumber;

            var codeLensLineNumber = _this3._lenses[codeLensIndex].getLineNumber();

            if (codeLensLineNumber < symbolsLineNumber) {
              _this3._lenses[codeLensIndex].dispose(helper, viewZoneAccessor);

              _this3._lenses.splice(codeLensIndex, 1);
            } else if (codeLensLineNumber === symbolsLineNumber) {
              _this3._lenses[codeLensIndex].updateCodeLensSymbols(groups[groupsIndex], helper);

              groupsIndex++;
              codeLensIndex++;
            } else {
              _this3._lenses.splice(codeLensIndex, 0, new CodeLensWidget(groups[groupsIndex], _this3._editor, _this3._styleClassName, helper, viewZoneAccessor, function () {
                return _this3._detectVisibleLenses && _this3._detectVisibleLenses.schedule();
              }));

              codeLensIndex++;
              groupsIndex++;
            }
          } // Delete extra code lenses


          while (codeLensIndex < _this3._lenses.length) {
            _this3._lenses[codeLensIndex].dispose(helper, viewZoneAccessor);

            _this3._lenses.splice(codeLensIndex, 1);
          } // Create extra symbols


          while (groupsIndex < groups.length) {
            _this3._lenses.push(new CodeLensWidget(groups[groupsIndex], _this3._editor, _this3._styleClassName, helper, viewZoneAccessor, function () {
              return _this3._detectVisibleLenses && _this3._detectVisibleLenses.schedule();
            }));

            groupsIndex++;
          }

          helper.commit(decorationsAccessor);
        });
      });

      scrollState.restore(this._editor);
    }
  }, {
    key: "_onViewportChanged",
    value: function _onViewportChanged() {
      var _this4 = this;

      if (this._currentResolveCodeLensSymbolsPromise) {
        this._currentResolveCodeLensSymbolsPromise.cancel();

        this._currentResolveCodeLensSymbolsPromise = undefined;
      }

      var model = this._editor.getModel();

      if (!model) {
        return;
      }

      var toResolve = [];
      var lenses = [];

      this._lenses.forEach(function (lens) {
        var request = lens.computeIfNecessary(model);

        if (request) {
          toResolve.push(request);
          lenses.push(lens);
        }
      });

      if (toResolve.length === 0) {
        return;
      }

      var resolvePromise = createCancelablePromise(function (token) {
        var promises = toResolve.map(function (request, i) {
          var resolvedSymbols = new Array(request.length);
          var promises = request.map(function (request, i) {
            if (!request.symbol.command && typeof request.provider.resolveCodeLens === 'function') {
              return Promise.resolve(request.provider.resolveCodeLens(model, request.symbol, token)).then(function (symbol) {
                resolvedSymbols[i] = symbol;
              }, onUnexpectedExternalError);
            } else {
              resolvedSymbols[i] = request.symbol;
              return Promise.resolve(undefined);
            }
          });
          return Promise.all(promises).then(function () {
            if (!token.isCancellationRequested && !lenses[i].isDisposed()) {
              lenses[i].updateCommands(resolvedSymbols);
            }
          });
        });
        return Promise.all(promises);
      });
      this._currentResolveCodeLensSymbolsPromise = resolvePromise;

      this._currentResolveCodeLensSymbolsPromise.then(function () {
        if (_this4._currentCodeLensModel) {
          // update the cached state with new resolved items
          _this4._codeLensCache.put(model, _this4._currentCodeLensModel);
        }

        _this4._oldCodeLensModels.clear(); // dispose old models once we have updated the UI with the current model


        if (resolvePromise === _this4._currentResolveCodeLensSymbolsPromise) {
          _this4._currentResolveCodeLensSymbolsPromise = undefined;
        }
      }, function (err) {
        onUnexpectedError(err); // can also be cancellation!

        if (resolvePromise === _this4._currentResolveCodeLensSymbolsPromise) {
          _this4._currentResolveCodeLensSymbolsPromise = undefined;
        }
      });
    }
  }, {
    key: "getLenses",
    value: function getLenses() {
      return this._lenses;
    }
  }]);

  return CodeLensContribution;
}();

CodeLensContribution.ID = 'css.editor.codeLens';
CodeLensContribution = __decorate([__param(1, ICommandService), __param(2, INotificationService), __param(3, ICodeLensCache)], CodeLensContribution);
export { CodeLensContribution };
registerEditorContribution(CodeLensContribution.ID, CodeLensContribution);
registerEditorAction( /*#__PURE__*/function (_EditorAction) {
  _inherits(ShowLensesInCurrentLine, _EditorAction);

  var _super = _createSuper(ShowLensesInCurrentLine);

  function ShowLensesInCurrentLine() {
    _classCallCheck(this, ShowLensesInCurrentLine);

    return _super.call(this, {
      id: 'codelens.showLensesInCurrentLine',
      precondition: EditorContextKeys.hasCodeLensProvider,
      label: localize('showLensOnLine', "Show CodeLens Commands For Current Line"),
      alias: 'Show CodeLens Commands For Current Line'
    });
  }

  _createClass(ShowLensesInCurrentLine, [{
    key: "run",
    value: function run(accessor, editor) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var quickInputService, commandService, notificationService, lineNumber, codelensController, items, _iterator5, _step5, lens, _iterator6, _step6, _item, command, item;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (editor.hasModel()) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                quickInputService = accessor.get(IQuickInputService);
                commandService = accessor.get(ICommandService);
                notificationService = accessor.get(INotificationService);
                lineNumber = editor.getSelection().positionLineNumber;
                codelensController = editor.getContribution(CodeLensContribution.ID);
                items = [];
                _iterator5 = _createForOfIteratorHelper(codelensController.getLenses());

                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                    lens = _step5.value;

                    if (lens.getLineNumber() === lineNumber) {
                      _iterator6 = _createForOfIteratorHelper(lens.getItems());

                      try {
                        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                          _item = _step6.value;
                          command = _item.symbol.command;

                          if (command) {
                            items.push({
                              label: command.title,
                              command: command
                            });
                          }
                        }
                      } catch (err) {
                        _iterator6.e(err);
                      } finally {
                        _iterator6.f();
                      }
                    }
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }

                if (!(items.length === 0)) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return");

              case 12:
                _context.next = 14;
                return quickInputService.pick(items, {
                  canPickMany: false
                });

              case 14:
                item = _context.sent;

                if (item) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return");

              case 17:
                _context.prev = 17;
                _context.next = 20;
                return commandService.executeCommand.apply(commandService, [item.command.id].concat(_toConsumableArray(item.command.arguments || [])));

              case 20:
                _context.next = 25;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](17);
                notificationService.error(_context.t0);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[17, 22]]);
      }));
    }
  }]);

  return ShowLensesInCurrentLine;
}(EditorAction));